<template>
  <div class="socials">
    <a href="#" class="facebook" target="_blank"></a>
    <a href="#" class="twitter" target="_blank"></a>
    <a href="#" class="instagram" target="_blank"></a>
  </div>
</template>

<script>
export default {
  name: 'socials',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/socials.vue